import { render } from "./CategoryChart.vue?vue&type=template&id=0ba3b924&scoped=true"
import script from "./CategoryChart.vue?vue&type=script&lang=js"
export * from "./CategoryChart.vue?vue&type=script&lang=js"

import "./CategoryChart.vue?vue&type=style&index=0&id=0ba3b924&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba3b924"]])

export default __exports__